export const MODAL_NAME = 'my-orders-ask-bill-modal'
